import { render } from "./configDetail.vue?vue&type=template&id=3582da7e&scoped=true"
import script from "./configDetail.vue?vue&type=script&lang=js"
export * from "./configDetail.vue?vue&type=script&lang=js"

import "./configDetail.vue?vue&type=style&index=0&id=3582da7e&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3582da7e"]])

export default __exports__